import { ChainIdEnum } from "../../../enums/chain";
import { ChainConfig } from "../types";
import { MEGAETH_BRANDING, envRpcUrls, getPerpetualDexConfig } from "./shared";

// ============================================
// MEGAETH TESTNET (Chain ID: 6343)
// ============================================
export const megaethTestnetConfig: ChainConfig = {
  chainId: ChainIdEnum.MEGAETH_TESTNET,
  name: "MegaETH Testnet",
  shortName: "megaeth",
  isTestnet: true,
  // MegaETH's RPC is keyed: never committed, supplied by REACT_APP_RPC_URL.
  rpcUrls: envRpcUrls(),
  wsUrl: process.env.REACT_APP_WSS_URL,
  explorerUrl: "https://megaexplorer.xyz",
  l2ExplorerUrl: "https://megaexplorer.xyz",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  tokenDecimals: {
    usdc: parseInt(process.env.REACT_APP_USDC_DECIMALS || "6", 10),
    usdt: 6,
    weth: 18,
    wbtc: 8,
    sdai: 6,
  },
  contracts: {
    erc20: {
      usdc: "0x9a0564C7c8B3950dD8d529D8Ae3b2127cB069d42",
      "usdc-native": "",
      usdt: "",
      weth: "0x4200000000000000000000000000000000000006",
      wbtc: "",
      l2usdc: "",
      l2usdt: "",
      l2weth: "",
      l2wbtc: "",
      govToken: "",
    },
    bridge: {
      l1DepositHelper: "0x5FC8d32690cc91D4c39d9d3abcBD16989F875707",
      l1StandardBridge: "0x9fE46736679d2D9a65F0992F2272dE9f3c7fa6e0",
      l2StandardBridge: "0xa513E6E4b8f2a923D98304ec87F64353C4D5C853",
      l2WithdrawProxy: "0x9A676e781A523b5d0C0e43731313A708CB607508",
      exchangePass: "",
      strategies: "",
      staking: "",
    },
    // perpetualDex loaded from deployments/6343.json if available
    perpetualDex: getPerpetualDexConfig(ChainIdEnum.MEGAETH_TESTNET, {
      router: "0x3527185aBF1428d3B2BF2301254AC1c5475eD7e9",
      crossMargin: "",
      orderHandler: "0x3527185aBF1428d3B2BF2301254AC1c5475eD7e9",
      orderVault: "",
      marketFactory: "0xe4Ee6c124405175E9658532718724b282e2Ba3F3",
      usdc: "0x9a0564C7c8B3950dD8d529D8Ae3b2127cB069d42",
      unifiedVault: "0x5a5696cA7cb080c76c90a717fc00beF29858C6b9",
      unifiedMarginAdapter: "0x175f7BE89B97CEd19B070DD793Fb239aC6dCa6D0",
      positionHandler: "0x472a21817aD12b8cCbdbB69C47b5141De11fD269",
      backstopVault: "0x19cF7Df0C3e96CB39510E0435Da4179fe16Feda6",
      oracle: "0x2ff334055F1EF980032cA23B18bE37dEd2e0cD56",
      dataStore: "0x7e4372bE7e0c994978750952fc6C70D6361DB45C",
      marketHandler: "0x09Cf0bA739Fd81CC6EFB502eD5989B1aFCE41Be7",
      markets: {
        "BTC-PERP": "0x270b1A6c72429E4ab9e474f21501bDEce6609e9B",
        "ETH-PERP": "0xe4d4426C1cad9E504c5C410AC89f09f40443D600",
      },
    }),
  },
  signingDomain: { name: "MarginX MegaETH Testnet", version: "1" },
  branding: MEGAETH_BRANDING,
};
